<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsShareAppointments"
      :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
      :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
      :filter-sync-enabled="true" show-row-lines="true" show-column-lines="false"
      @selection-changed="onSelectionChanged" @row-inserting="onRowInserting" @row-removing="onRowRemoving"
      class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="0" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="ShareAppointments" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="300">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem data-field="Utilizator">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="ShareLa" />
          </DxItem>
        </DxFormGrid>
      </DxEditing>
      <DxColumn data-field="Utilizator" />
      <DxColumn data-field="ShareLa" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="530" :height="300">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
          Adăugare</div>
      </template>
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem dataField="Utilizator" isRequired="true">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="ShareLa" />
          </DxItem>
        </DxForm>
        <div style="display: flex; justify-content: flex-end; gap: 8px;">
          <DxButton text="Salvează" type="success" width="100" @click="onSave" />
          <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
        </div>
      </div>
    </DxPopupAdd>
  </body>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import CrmNomenclatoare from '@/services/Comercial/CrmNomenclatoare';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmShareAppointments from '@/services/Comercial/CrmShareAppointments';
export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
  },
  data() {
    return {
      dsShareAppointments: {} as ODataStore,
      isModalVisible: false,
      formData: {
        Utilizator: '',
        ShareLa: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
          <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white; 
          font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
      },
    };
  },
  methods: {
    createODataContext() {
      this.dsShareAppointments = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_ShareAppointments',
        key: 'ID',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
          };
        },
      });
    },
    onSelectionChanged(e: any) {
      const selectedRow = e.selectedRowsData[0];
      this.$emit('selection-changed', selectedRow.ID);
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      if (!this.formData.Utilizator || this.formData.Utilizator.trim() === '') {
        notify('Completați câmpul obligatoriu "Utilizator"!', 'error', 1000);
        return;
      }
      if (!this.formData.ShareLa || this.formData.ShareLa.trim() === '') {
        notify('Completați câmpul obligatoriu "ShareLa"!', 'error', 1000);
        return;
      }
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      CrmShareAppointments.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {
          Utilizator: '',
          ShareLa: '',
        };
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja!', 'error', 1000);
      });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSaveEdit() {
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      savePromise.then((result) => {
        this.dataGridRef?.instance?.saveEditData();
      }).catch((error) => {
        console.error(error);
      });
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onRowInserting() {
      notify('Datele au fost adăugate cu succes!', 'success', 1000)
    },
  },
  mounted() {
    this.createODataContext();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });
    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>